import { getCmsSpecialFareOfferDetail } from "../../../app/api/getCmsSpecialFareOffer";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import {
  ICmsSpecialFareOfferResponse,
} from "../../../Orchestrator/Types/Interface/ICMSOffers";

class GetCmsSpecialFareOfferDetailAction extends BaseAction<ICmsSpecialFareOfferResponse | null, { slug: string }> {
  override async run(): Promise<ICmsSpecialFareOfferResponse | null> {
    let result: ICmsSpecialFareOfferResponse | null = null;
    try {
      const response: IApiResponse<ICmsSpecialFareOfferResponse> = await getCmsSpecialFareOfferDetail(this.params?.slug!);

      if (response.status === "ok" && response.answer) {
        result = response.answer;
      } else {
        console.warn("Failed to fetch Offers.");
      }
    } catch (error: any) {
      console.error("Error fetching Offers:", error);
    } finally {
      updateRecoilState("cmsSpecialFareOfferDetailResponseAtom", result);
      return result;
    }
  }
}

export const getCmsSpecialFareOfferDetailAction = new GetCmsSpecialFareOfferDetailAction();
